






















import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class ToggleSwitch extends Vue {
  @Prop() private value!: boolean

  @Emit('input')
  public onInput (value: boolean) { /**/ }

  private onClick () {
    this.onInput(!this.value)
  }
}
